import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { OcrSwitchLayout, OcrTableLayout } from '.';

export function OcrComplianceTableLayout(
    {
        loading = false,
        disabled = false,
        readonly = false,
        tableExpanded = false,
        tableExpandable = false,
        previsit = {},
        filterOn = false,
        assets,
        booleanNaSelectValues,
        booleanSelectValues,
        editableColumnTypes,
        employees,
        getColumnTypeForCell,
        layout,
        onChange
    }
) {


    function filterRow(row, rowIndex) {
        if (layout.answer && (layout.answer === "true" || layout.answer === true)) {
            const passFailcolumnIndexes = layout.table.columns.map((column, index) => {
                if (column.columnType === "PassFail") {
                    return index;
                }
                return undefined;
            }).filter(index => index !== undefined);

            if (passFailcolumnIndexes.length > 0) {

                for (let i = 0; i < passFailcolumnIndexes.length; i++) {
                    if (row[passFailcolumnIndexes[i]] === "False" || row[passFailcolumnIndexes[i]] === "na") {
                        return true;
                    }
                }
            }

            return false;
        } else {
            return true;
        }
    }

    function onChangeValue(layoutValue) {

        onChange(layoutValue);
    }

    return (
        <Fragment>

            <div>            
                <OcrSwitchLayout                    
                    loading={loading}
                    layout={layout}
                    disabled={disabled || readonly}
                    label="Non compliant only: "
                    onChange={onChangeValue}>
                    </OcrSwitchLayout>
            </div>
            <OcrTableLayout
                layout={layout}
                rowFilter={filterRow}
                loading={loading}
                onChange={onChange}
                employeeList={employees}
                assetList={assets}
                disabled={disabled}
                booleanSelectValues={booleanSelectValues}
                booleanNaSelectValues={booleanNaSelectValues}
                editableColumnTypes={editableColumnTypes}
                getColumnTypeForCell={getColumnTypeForCell}
                readonly={readonly}
                tableExpanded={tableExpanded}
                tableExpandable={tableExpandable}
                previsit={previsit} />
        </Fragment>
    );

}

OcrComplianceTableLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    employeeList: PropTypes.array.isRequired,
    assetList: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    booleanSelectValues: PropTypes.array.isRequired,
    booleanNaSelectValues: PropTypes.array.isRequired,
    editableColumnTypes: PropTypes.array.isRequired,
    getColumnTypeForCell: PropTypes.func.isRequired,
    readonly: PropTypes.bool,
    tableExpanded: PropTypes.bool,
    tableExpandable: PropTypes.bool,
    previsit: PropTypes.object
};
